/** App role values and display labels */
export const ROLE_LABELS = {
  super_admin: 'Super Admin',
  bridge_owner: 'Bridge Owner',
  bridge_admin: 'Bridge Admin',
  bridge_manager: 'Bridge Manager',
  bridge_engineer: 'Bridge Engineer',
  // Legacy DB values (until migrate-role-names.js is run)
  project_manager: 'Bridge Manager',
  project_engineer: 'Bridge Engineer',
};

export const LOGIN_ROLE_OPTIONS = [
  { value: 'super_admin', label: ROLE_LABELS.super_admin },
  { value: 'bridge_owner', label: ROLE_LABELS.bridge_owner},
  { value: 'bridge_admin', label: ROLE_LABELS.bridge_admin },
  { value: 'bridge_manager', label: ROLE_LABELS.bridge_manager },
  { value: 'bridge_engineer', label: ROLE_LABELS.bridge_engineer },
];

export const ROLE_LABEL_NAMES = new Set(Object.values(ROLE_LABELS));
